// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7155f196","374":"1b51b3fa","444":"04e1d2c4","453":"1b7e48a8","455":"535df47d","557":"91a983fd","644":"445e795d","762":"df02bf2d"}[chunkId] + ".chunk.js";
};